import React from "react";
import MessageTemplateDataList from "./MessageTemplateDataList";
import MessageTemplateEditForm from "./MessageTemplateEditForm";

///////////////////// LIST ALL MESSAGE TEMPLATES /////////////////////
export const MessageTemplateList = props => <MessageTemplateDataList {...props} />;

///////////////////// UPDATE MESSAGE TEMPLETE /////////////////////
export const MessageTemplateEdit = props => <MessageTemplateEditForm {...props} />;


// WEBPACK FOOTER //
// ./src/containers/CRM/MessageTemplates/index.js